import Vue from "vue";
import VueRouter from "vue-router";
import Inicio from "../views/Inicio.vue";
import Denegado from "../views/Denegado.vue";
import errorPage from "../views/ErrorPage.vue";
import { tokenExpirado, redirectLoginExpirado } from "../utils/jwt";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Inicio",
    component: Inicio,
    meta: {
      rutaName: "inicio",
    },
  },
  {
    path: "/404",
    name: "Denegado",
    component: Denegado,
  },
  {
    path: "*",
    name: "ErrorPage",
    component: errorPage,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: () => import("../views/Usuarios.vue"),
    meta: {
      rutaName: "usuarios",
    },
  },
  {
    path: "/usuarios/add",
    name: "UsuariosAdd",
    component: () => import("../views/usuarios/UserAdd.vue"),
    meta: {
      rutaName: "usuarios/add",
    },
  },
  {
    path: "/productos",
    name: "Productos",
    component: () => import("../views/productos/Productos.vue"),
    meta: {
      rutaName: "productos",
    },
  },
  {
    path: "/cargar-productos-con-excel",
    name: "CargarProductosConExcel",
    component: () => import("../views/productos/CargarProductosConExcel.vue"),
    meta: {
      rutaName: "cargar-productos-con-excel",
    },
  },
  {
    path: "/radar",
    name: "Radar",
    component: () => import("../views/Radar/Radar.vue"),
    meta: {
      rutaName: "radar",
    },
  },
  {
    path: "/productos/add",
    name: "ProductosAdd",
    component: () => import("../views/productos/ProductosAdd.vue"),
    meta: {
      rutaName: "productos/add",
    },
  },
  {
    path: "/productos/edit/:id",
    name: "ProductosEdit",
    component: () => import("../views/productos/ProductosEdit.vue"),
    meta: {
      rutaName: "productos/edit",
    },
  },
  {
    path: "/parametros",
    name: "Parametros",
    component: () => import("../views/Parametros.vue"),
    meta: {
      rutaName: "parametros",
    },
  },
  {
    path: "/parametros/Marcas",
    redirect: "/marcas",
  },
  {
    path: "/marcas",
    name: "Marcas",
    component: () => import("../views/marcas/Marcas.vue"),
    meta: {
      rutaName: "marcas",
    },
  },
  {
    path: "/marcas/add",
    redirect: "/marcas",
  },
  {
    path: "/marcas/edit/:id",
    redirect: "/marcas",
  },
  {
    path: "/compras",
    name: "compras",
    component: () => import("../views/compras/ComprasView.vue"),
    meta: {
      rutaName: "compras",
    },
  },
  {
    path: "/compras/sucursal/:id",
    name: "compras-sucursal",
    component: () => import("../views/compras/ComprasSucursalView.vue"),
    meta: {
      rutaName: "compras/sucursal",
    },
  },
  {
    path: "/compras/ordenes",
    name: "compras-ordenes",
    component: () => import("../views/compras/ComprasOdenesFinalView.vue"),
    meta: {
      rutaName: "compras/ordenes",
    },
  },
  {
    path: "/compras/transferencias",
    name: "compras-transferencias",
    component: () => import("../views/compras/TransferenciasView.vue"),
    meta: {
      rutaName: "compras/transferencias",
    },
  },
  {
    path: "/compras/salida-ordenes",
    name: "salida-ordenes",
    component: () => import("../views/compras/TransferenciasView.vue"),
    meta: {
      rutaName: "compras/salida-ordenes",
    },
  },
  {
    path: "/compras/salida-ordenes/trabajar/:id",
    name: "salida-ordenes-id",
    component: () => import("../views/compras/TrabajarSolicitudTransferenciaView.vue"),
    meta: {
      rutaName: "compras/salida-ordenes/trabajar",
    },
  },
  {
    path: "/compras/salida-ordenes/salida-mercaderia/:id",
    name: "salida-mercaderia",
    component: () => import("../views/compras/SalidaMercaderiaOrdenesCompraView.vue"),
    meta: {
      rutaName: "compras/salida-ordenes/salida-mercaderia",
    },
  },
  {
    path: "/compras/nuevo-despacho",
    name: "nuevo-despacho",
    component: () => import("../views/compras/NuevoDespachoView.vue"),
    meta: {
      rutaName: "compras/nuevo-despacho",
    },
  },
    {
    path: "/compras/ordenes/recibir-mercarderia/:id",
    name: "recibir-mercaderia",
    component: () => import("../views/compras/ComprasRecibirMercaderiaView.vue"),
    meta: {
      rutaName: "compras/ordenes/recibir-mercarderia",
    },
  },
  
  {
    path: "/compras/recepcion-mercaderia",
    name: "recepcion-mercaderia",
    component: () => import("../views/compras/RecepcionMercaderiaView.vue"),
    meta: {
      rutaName: "compras/recepcion-mercaderia",
    },
  },
  {
    path: "/configuracion/impresoras",
    name: "configuracion-impresoras",
    component: () =>
      import("../views/configuraciones/ImpresorasConfigView.vue"),
    meta: {
      rutaName: "configuracion/impresoras",
    },
  },
  {
    path: "/configuracion/cajas",
    name: "configuracion-cajas",
    component: () =>
      import("../views/configuraciones/CajasConfigView.vue"),
    meta: {
      rutaName: "configuracion/cajas",
    },
  },
  {
    path: "/configuracion/cajas/cuenta-posnet",
    name: "configuracion-cajas-cuenta-posnet",
    component: () =>
      import("../views/configuraciones/CuentaPosnetView.vue"),
    meta: {
      // #372 Tramo 1 — PENDIENTE de sembrar (sql/mike/nuevos/...), no se adivina el id_ruta.
      rutaName: "configuracion/cajas/cuenta-posnet",
    },
  },
  {
    path: "/configuracion",
    name: "Configuracion",
    component: () =>
      import("../views/configuraciones/ConfiguracionesViews.vue"),
    meta: {
      rutaName: "configuracion",
    },
  },
  {
    path: "/categorias",
    name: "Categorias",
    component: () => import("../views/categorias/Categorias.vue"),
    meta: {
      rutaName: "categorias",
    },
  },
  {
    path: "/categorias/add",
    redirect: "/categorias",
  },
  {
    path: "/categorias/edit/:id",
    redirect: "/categorias",
  },
  {
    path: "/subcategoria",
    name: "SubCategorias",
    component: () => import("../views/subcategorias/SubCategorias.vue"),
    meta: {
      rutaName: "subcategorias",
    },
  },
  {
    path: "/subcategorias/add",
    redirect: "/subcategoria",
  },
  {
    path: "/subcategoria/edit/:id",
    redirect: "/subcategoria",
  },
  {
    path: "/proveedores",
    name: "Proveedores",
    component: () => import("../views/proveedores/Proveedores.vue"),
    meta: {
      rutaName: "proveedores",
    },
  },
  {
    path: "/clientes",
    name: "Clientes",
    component: () => import("../views/clientes/Clientes.vue"),
    meta: {
      rutaName: "clientes",
    },
  },
  {
    // El alta y la edición de clientes ahora se hacen con ClienteDialog desde
    // /clientes. Estas rutas quedan como redirect (no se borran directo) porque
    // Cobros.vue todavía arma un link a /clientes/edit/:id (método muerto, sin
    // botón que lo dispare, pero mejor no romperlo si algún día se reconecta).
    path: "/clientes/add",
    redirect: "/clientes",
  },
  {
    path: "/clientes/edit/:id",
    redirect: "/clientes",
  },
  {
    path: "/ventas",
    name: "ventas",
    component: () => import("../views/ventas/Ventas.vue"),
    meta: {
      rutaName: "ventas",
    },
  },
  {
    path: "/admin-ventas",
    name: "admin-ventas",
    component: () => import("../views/admin-ventas/AdminVentas.vue"),
    meta: {
      rutaName: "admin-ventas",
    },
  },
  {
    path: "/admin-ventas/edit/:id",
    name: "admin-ventas-edit",
    component: () => import("../views/admin-ventas/AdminVentasEdit.vue"),
    meta: {
      rutaName: "admin-ventas/edit",
    },
  },
  {
    path: "/deposito",
    name: "deposito",
    component: () => import("../views/deposito/Deposito.vue"),
    meta: {
      rutaName: "deposito",
    },
  },
  {
    path: "/deposito/edit/:id",
    name: "deposito-edit",
    component: () => import("../views/deposito/AdminVentasEditDeposito.vue"),
    meta: {
      rutaName: "deposito/edit",
    },
  },
  {
    path: "/estadisticas",
    name: "estadisticas",
    component: () => import("../views/estadisticas/Estadisticas.vue"),
    meta: {
      rutaName: "estadisticas",
    },
  },
  {
    path: "/reportes",
    name: "reportes",
    component: () => import("../views/estadisticas/Reportes.vue"),
    meta: {
      rutaName: "reportes",
    },
  },
  {
    path: "/reportes/detalle",
    name: "reportes-detalle",
    component: () => import("../views/estadisticas/ReportesDetalle.vue"),
    meta: {
      rutaName: "reportes/detalle",
    },
  },
  {
    path: "/estadisticas-pos",
    name: "estadisticas-pos",
    component: () => import("../views/EstadisticasPos.vue"),
    meta: {
      rutaName: "estadisticas-pos",
    },
  },

  {
    path: "/reparto",
    name: "reparto",
    component: () => import("../views/finazansas/RepartoView.vue"),
    meta: {
      rutaName: "reparto",
    },
  },
  {
    path: "/reparto/resumen/:id",
    name: "reparto_resumen",
    component: () => import("../views/finazansas/RepartoResumenView.vue"),
    meta: {
      rutaName: "reparto/resumen",
    },
  },
  {
    // Trello #404 "Rutas del día" — planificación de rutas de entrega por repartidor/fecha.
    // rutaName seedeado por la migración de backend (menú); distinto de "reparto" (liquidación).
    path: "/rutas-reparto",
    name: "rutas_reparto",
    component: () => import("../views/rutas-reparto/RutasReparto.vue"),
    meta: {
      rutaName: "rutas-reparto",
    },
  },
  {
    path: "/cobros",
    name: "cobros",
    component: () => import("../views/estadisticas/Cobros.vue"),
    meta: {
      rutaName: "cobros",
    },
  },
  
  {
    path: "/pagos",
    name: "pagos",
    component: () => import("../views/finazansas/PagosView.vue"),
    meta: {
      rutaName: "pagos",
    },
  },
  {
    path: "/egresos",
    name: "egresos",
    component: () => import("../views/Egresos.vue"),
    meta: {
      rutaName: "egresos",
    },
  },
  {
    path: "/finanzas/liquidaciones",
    name: "liquidaciones",
    component: () => import("../views/finazansas/LiquidacionesView.vue"),
    meta: {
      rutaName: "finanzas/liquidaciones",
    },
  },
  {
    path: "/finanzas/liquidaciones/:id",
    name: "liquidacion_detalle",
    component: () => import("../views/finazansas/LiquidacionDetalleView.vue"),
    meta: {
      rutaName: "finanzas/liquidaciones/:id",
    },
  },
  {
    path: "/productos/actualizar_stock",
    name: "actualizar_stock",
    component: () => import("../views/productos/ActualizaStockView.vue"),
    meta: {
      rutaName: "productos/actualizar_stock",
    },
  },
  // {
  //   path: "/compras",
  //   name: "compras",
  //   component: () => import("../views/compras/ComprasView.vue"),
  //   meta: {
  //     rutaName: "compras",
  //   },
  // },
  {
    path: "/productos/ofertas",
    name: "Ofertas",
    component: () => import("../views/ofertas/Ofertas.vue"),
    meta: {
      rutaName: "productos/ofertas",
    },
  },
  {
    path: "/productos/productos_compuestos",
    name: "ProductosCompuestos",
    component: () => import("../views/productos/ProductosCompuestos.vue"),
    meta: {
      rutaName: "productos/productos_compuestos",
    },
  },
  {
    path: "/productos/productos_compuestos/add-edit/:id",
    name: "ProductosCompuestosAddEdit",
    component: () => import("../views/productos/ProductosCompuestosAddEdit.vue"),
    meta: {
      rutaName: "productos/productos_compuestos/add-edit",
    },
  },
  
  {
    path: "/productos/ofertas/add-edit/:id",
    name: "OfertasAdmin",
    component: () => import("../views/ofertas/OfertasAdmin.vue"),
    meta: {
      rutaName: "productos/ofertas/add-edit",
    },
  },
  {
    path: "/listas-precios",
    name: "ListasPrecios",
    component: () => import("../views/listas-precios/ListasPrecios.vue"),
    meta: {
      rutaName: "listas-precios",
    },
  },
  {
    path: "/listas-precios/add",
    name: "ListasPreciosAdd",
    component: () => import("../views/listas-precios/ListasPreciosAdd.vue"),
    meta: {
      rutaName: "listas-precios/add",
    },
  },
  {
    path: "/listas-precios/edit/:id",
    name: "ListasPreciosEdit",
    component: () => import("../views/listas-precios/ListasPreciosEdit.vue"),
    meta: {
      rutaName: "listas-precios/edit",
    },
  },
  {
    path: "/impuestos",
    name: "Impuestos",
    component: () => import("../views/Impuestos.vue"),
    meta: {
      rutaName: "impuestos",
    },
  },
  {
    path: "/pos",
    name: "pos",
    component: () => import("../views/pos/Pos.vue"),
    meta: {
      rutaName: "pos",
    },
  },
  {
    path: "/nota-credito",
    name: "notaCredito",
    component: () => import("../views/pos/NotaCredito.vue"),
    meta: {
      rutaName: "nota-credito",
    },
  },
  {
    path: "/pos/caja/:tipo/:id",
    name: "cierreCaja",
    component: () => import("../views/pos/cierreCaja.vue"),
    meta: {
      rutaName: "pos/caja/cierre",
    },
  },
  {
    path: "/cajas",
    name: "cajas",
    component: () => import("../views/pos/Cajas.vue"),
    meta: {
      rutaName: "cajas",
    },
  },
  {
    path: "/promo-redes",
    name: "promo-redes",
    component: () => import("../views/promos/AdminPromos.vue"),
    meta: {
      rutaName: "promo-redes",
    },
  },
  {
    path: "/stock",
    name: "stock",
    component: () => import("../views/stock/StockView.vue"),
    meta: {
      rutaName: "stock",
    },
  },
  {
    path: "/stock/inventario",
    name: "stock-inventario",
    component: () => import("../views/stock/InventoryView.vue"),
    meta: {
      rutaName: "stock/inventario",
    },
  },
  // Producción de productos compuestos (#544): comparte el permiso de pantalla
  // de productos compuestos, como hacen otras sub-rutas con un mismo rutaName.
  {
    path: "/stock/produccion",
    name: "stock-produccion",
    component: () => import("../views/stock/RegistrarProduccionView.vue"),
    meta: {
      rutaName: "productos/productos_compuestos",
    },
  },
  {
    path: "/stock/producciones",
    name: "stock-producciones",
    component: () => import("../views/stock/ProduccionesView.vue"),
    meta: {
      rutaName: "productos/productos_compuestos",
    },
  },
  // Ruta eliminada: ya no es necesaria porque ahora usamos v-viewer para visualizar imágenes
  {
    path: "/rubros",
    name: "rubros",
    component: () => import("../views/rubros/Rubros.vue"),
    meta: {
      rutaName: "rubros",
    },
  },
  {
    path: "/rubros/edit/:id",
    name: "rubrosEdit",
    component: () => import("../views/rubros/RubrosEdit.vue"),
    meta: {
      rutaName: "rubros/edit",
    },
  },
  {
    path: "/rubros/add",
    name: "rubrosAdd",
    component: () => import("../views/rubros/RubrosAdd.vue"),
    meta: {
      rutaName: "rubros/add",
    },
  },
  {
    path: "/rubros/asignar-productos",
    name: "rubrosProductosAdd",
    component: () => import("../views/rubros/RubroProductoAdd.vue"),
    meta: {
      rutaName: "rubros/asignar-productos",
    },
  },
  {
    path: "/marcas-rubros",
    name: "marcasRubros",
    component: () => import("../views/marcas-rubros/MarcaRubros.vue"),
    meta: {
      rutaName: "marcas-rubros",
    },
  },
  {
    path: "/marcas-rubros/edit/:id",
    name: "marcasRubrosEdit",
    component: () => import("../views/rubros/RubroProductoAdd.vue"),
    meta: {
      rutaName: "marcas-rubros/edit",
    },
  },
  {
    path: "/marcas-rubros/add",
    name: "marcasRubrosAdd",
    component: () => import("../views/marcas-rubros/MarcaRubrosAdd.vue"),
    meta: {
      rutaName: "marcas-rubros/add",
    },
  },
  {
    path: "/cuentas-corrientes",
    name: "cuentasCorrientes",
    component: () =>
      import("../views/cuentas-corrientes/CuentasCorrientes.vue"),
    meta: {
      rutaName: "cuentas-corrientes",
    },
  },
  {
    path: "/cuentas-corrientes/clientes",
    name: "cuentasCorrientesClientes",
    component: () =>
      import("../views/cuentas-corrientes/CuentasCorrientesClientesView.vue"),
    meta: {
      rutaName: "cuentas-corrientes/clientes",
    },
  },
  {
    path: "/cuentas-corrientes/proveedores",
    name: "cuentasCorrientesProveedores",
    component: () =>
      import("../views/cuentas-corrientes/CuentasCorrientesProveedoresView.vue"),
    meta: {
      rutaName: "cuentas-corrientes/proveedores",
    },
  },
  {
    path: "/cuentas-corrientes/clientes/movimientos",
    name: "cuentasCorrientesClientesMovimientos",
    component: () =>
      import("../views/cuentas-corrientes/DetalleMovimientosClientes.vue"),
    meta: {
      rutaName: "cuentas-corrientes/clientes/movimientos",
    },
  },
  {
    path: "/cuentas-corrientes/clientes/pedidos-deuda",
    name: "pedidosDeudaCCCliente",
    component: () =>
      import("../views/cuentas-corrientes/PedidosDeudaCCClienteView.vue"),
    meta: {
      requiresAuth: true,
      rutaName: "cuentas-corrientes/clientes/pedidos-deuda",
    },
  },
  {
    path: "/cuentas-corrientes/proveedores/movimientos",
    name: "cuentasCorrientesProveedoresMovimientos",
    component: () =>
      import("../views/cuentas-corrientes/DetalleMovimientosProveedores.vue"),
    meta: {
      rutaName: "cuentas-corrientes/proveedores/movimientos",
    },
  },
  {
    path: "/cuentas-empresa",
    name: "cuentasEmpresa",
    component: () =>
      import("../views/cuentas-empresa/CuentasEmpresaView.vue"),
    meta: {
      rutaName: "cuentas-empresa",
    },
  },
  {
    path: "/cuentas-empresa/dashboard",
    name: "cuentas-empresa-dashboard",
    component: () =>
      import("../views/cuentas-empresa/CuentasEmpresaView.vue"),
    meta: {
      rutaName: "cuentas-empresa/dashboard",
    },
  },
  {
    path: "/cuentas-empresa/movimientos/:id",
    name: "cuentas-empresa-movimientos",
    component: () =>
      import("../views/cuentas-empresa/MovimientosCuentaView.vue"),
    meta: {
      rutaName: "cuentas-empresa/movimientos",
    },
  },
  {
    path: "/cuentas-empresa/detalle",
    name: "cuentas-empresa-detalle",
    component: () =>
      import("../views/cuentas-empresa/DetalleCuentaView.vue"),
    meta: {
      rutaName: "cuentas-empresa/detalle",
    },
  },
  {
    path: "/cuentas-empresa/vinculos",
    name: "cuentas-empresa-vinculos",
    component: () =>
      import("../views/cuentas-empresa/VinculoMediosPagoView.vue"),
    meta: {
      // Sembrada por sql/mike/ejecutados/20260828_1030_rutas_cuentas_medios_pago.sql
      rutaName: "cuentas-empresa/vinculos",
    },
  },
  {
    path: "/integraciones",
    name: "integraciones",
    component: () =>
      import("../views/integraciones/IntegracionesView.vue"),
    meta: {
      // Pendiente sembrar: fila de permiso rutaName + entrada de menú (Trello #351).
      // Ver "Backend seeds required" en la entrega de la tarea — ids reales sin verificar
      // contra la base viva, no se proponen acá.
      rutaName: "integraciones",
    },
  },
  {
    path: "/cuentas-empresa/corte",
    name: "cuentas-empresa-corte",
    component: () =>
      import("../views/cuentas-empresa/CorteFechaView.vue"),
    meta: {
      // Sembrada por sql/mike/nuevos/20260902_1400_ruta_corte_cuentas_medios_pago.sql
      rutaName: "cuentas-empresa/corte",
    },
  },
  {
    path: "/cuentas-empresa/estado-cuenta",
    name: "cuentas-empresa-estado-cuenta",
    component: () =>
      import("../views/cuentas-empresa/EstadoCuentaView.vue"),
    meta: {
      // Sembrada por sql/mike/nuevos/20260902_1600_ruta_estado_cuenta_cuentas_medios_pago.sql
      rutaName: "cuentas-empresa/estado-cuenta",
    },
  },
  {
    path: "/conciliacion",
    name: "conciliacion",
    component: () =>
      import("../views/finazansas/ConciliacionView.vue"),
    meta: {
      // id_ruta = 140, nacida en general_db (sql/mike/conciliacion-externa-general-db/)
      // y replicada por sql/mike/nuevos/YYYYMMDD_HHMM_ruta_140_conciliacion_tenant.sql (WU1)
      rutaName: "conciliacion",
    },
  },
  {
    path: "/editor-masivo",
    name: "editorMasivo",
    component: () =>
      import("../views/productos/EditorMasivoView.vue"),
    meta: {
      rutaName: "editor-masivo",
    },
  },
  {
    path: "/ecommerce/configuracion",
    name: "ecommerceConfiguracion",
    component: () =>
      import("../views/ecommerce/EcommerceConfiguracionView.vue"),
    meta: {
      rutaName: "ecommerce/configuracion",
    },
  },
  {
    path: "/ARCA/facturacion-manual",
    name: "facturacionManual",
    component: () =>
     import("../views/arca/FacturacionManual.vue"),
    meta: {
      rutaName: "ARCA/facturacion-manual",
    },
  },
  {
    path: "/ARCA/transacciones",
    name: "transacciones",
    component: () =>
     import("../views/arca/Transacciones.vue"),
    meta: {
      rutaName: "ARCA/transacciones",
    },
  },
  {
    path: "/ARCA/nota-credito",
    name: "nota-credito",
    component: () =>
     import("../views/arca/NotaCredito.vue"),
    meta: {
      rutaName: "ARCA/nota-credito",
    },
  },
  {
    path: "/ARCA/aprobacion-nc",
    name: "aprobacion-nc",
    component: () =>
     import("../views/arca/AprobacionNC.vue"),
    meta: {
      rutaName: "nota-credito-gestion/aprobar",
    },
  },
  {
    path: "/ARCA/configuracion",
    name: "arca-configuracion",
    component: () =>
     import("../views/arca/ConfiguracionArca.vue"),
    meta: {
      rutaName: "ARCA/configuracion",
    },
  },
  // ─── Códigos de Descuento ─────────────────────────────
  {
    path: "/codigo-descuento",
    name: "DiscountCodes",
    component: () => import("../views/promos/DiscountCodesPage.vue"),
    meta: {
      rutaName: "codigo-descuento",
    },
  },
  {
    path: "/codigo-descuento/:id",
    name: "DiscountCodeDetail",
    component: () => import("../views/promos/DiscountCodeDetailPage.vue"),
    meta: {
      rutaName: "codigo-descuento",
    },
  },
  // Novedades (changelog). Sin `rutaName` a propósito: la ve cualquier usuario
  // logueado, igual que /perfil. El guard de abajo deja pasar las rutas que no
  // declaran permiso, así no hace falta sembrar la ruta en cada tenant.
  {
    path: "/novedades",
    name: "Novedades",
    component: () => import("../views/novedades/Novedades.vue"),
  },
  // Tutoriales
  {
    path: "/tutoriales",
    name: "Tutoriales",
    component: () => import("../views/tutoriales/Tutoriales.vue"),
    meta: {
      rutaName: "tutoriales",
    },
  },
  // Guías de usuario (Centro de Aprendizaje): mismo permiso que /tutoriales
  {
    path: "/tutoriales/guia/:slug",
    name: "GuiaDetalle",
    component: () => import("../views/tutoriales/GuiaDetalle.vue"),
    meta: {
      rutaName: "tutoriales",
    },
  },
  // Planes / suscripciones (la ruta con typo matchea sys_menu existente)
  {
    path: "/mis-suspcripciones",
    name: "Planes",
    component: () => import("../views/planes/Plan.vue"),
    meta: {
      rutaName: "mis-suspcripciones",
    },
  },{
    path: "/productos/carniceria",
    name: "carniceria",
    component: () => import("../views/carniceria/Carniceria.vue"),
    meta: {
      rutaName: "productos/carniceria",
    },
  },
  {
    path: "/productos/carniceria/gestionar-cortes",
    name: "carniceria-gestionar-cortes",
    component: () => import("../views/carniceria/GestionarCortes.vue"),
    meta: {
      rutaName: "productos/carniceria",
    },
  },
  {
    path: "/productos/carniceria/nueva-carga",
    name: "carniceria-nueva-carga",
    component: () => import("../views/carniceria/NuevaCarga.vue"),
    meta: {
      rutaName: "productos/carniceria",
    },
  },
  {
    path: "/productos/carniceria/importar-cortes",
    name: "carniceria-importar-cortes",
    component: () => import("../views/carniceria/ImportarCortes.vue"),
    meta: {
      rutaName: "productos/carniceria",
    },
  },
  {
    path: "/etiquetas",
    name: "etiquetas",
    component: () => import("../views/productos/Etiquetas.vue"),
    meta: {
      rutaName: "etiquetas",
    },
  },
  // ─── Frigorífico ─────────────────────────────────────
  {
    path: "/frigorifico",
    name: "frigorifico",
    component: () => import("../views/frigorifico/FrigorificoListado.vue"),
    meta: {
      rutaName: "frigorifico",
    },
  },
  {
    path: "/frigorifico/historial/:codigo",
    name: "frigorifico-historial",
    component: () => import("../views/frigorifico/FrigorificoHistorial.vue"),
    meta: {
      rutaName: "frigorifico",
    },
  },
  {
    path: "/frigorifico/nueva-venta",
    name: "frigorifico-nueva-venta",
    component: () => import("../views/frigorifico/FrigorificoNuevaVenta.vue"),
    meta: {
      rutaName: "frigorifico",
    },
  },
  {
    // "Gestión de pedidos" (card #417): reemplaza la pantalla de
    // "Pedidos Ecommerce". Mantiene el mismo rutaName que la ruta vieja
    // para que los permisos ya otorgados sigan funcionando sin migración.
    path: "/gestion-pedidos",
    name: "gestion-pedidos",
    component: () => import("../views/admin-ventas/GestionPedidos.vue"),
    meta: {
      rutaName: "seguimiento-pedidos",
    },
  },
  {
    // Alias viejo: quien tenga el link guardado sigue llegando al tablero.
    path: "/seguimiento-pedidos",
    redirect: "/gestion-pedidos",
  },
  // ─── Preventistas ─────────────────────────────────────
  {
    path: "/administracion/preventistas",
    name: "Preventistas",
    component: () => import("../views/preventistas/PreventistasView.vue"),
    meta: {
      rutaName: "administracion/preventistas",
    },
  },
  {
    path: "/administracion/preventistas/config-global",
    name: "ConfigGlobalComisiones",
    component: () => import("../views/preventistas/GlobalConfigView.vue"),
    meta: {
      rutaName: "administracion/preventistas",
    },
  },
  {
    path: "/administracion/preventistas/:id",
    name: "PreventistaConfig",
    component: () => import("../views/preventistas/PreventistaConfigView.vue"),
    meta: {
      rutaName: "administracion/preventistas",
    },
  },
  {
    path: "/ARCA/facturacion-pedido",
    name: "FacturacionPedido",
    component: () => import("../views/arca/FacturacionPedido.vue"),
    meta: {
      rutaName: "ARCA/facturacion-pedido",
    },
  },
  // ─── Notificaciones ───────────────────────────────────
  {
    path: "/administracion/notificaciones",
    name: "NotificacionesCentro",
    component: () => import("../views/notificaciones/NotificacionesCentroView.vue"),
    meta: {
      rutaName: "notificaciones/centro",
    },
  },
  // ─── Roles y permisos (#385) — one seeded ruta guards the whole panel ───
  {
    path: "/administracion/roles-permisos",
    name: "RolesPermisos",
    component: () => import("../views/permisos/RolesPermisosView.vue"),
    meta: { rutaName: "roles-permisos" },
  },
  {
    path: "/administracion/roles-permisos/:id/acciones",
    name: "RolAcciones",
    component: () => import("../views/permisos/RolAccionesView.vue"),
    meta: { rutaName: "roles-permisos" },
  },
  {
    path: "/administracion/roles-permisos/:id/pantallas",
    name: "RolPantallas",
    component: () => import("../views/permisos/RolPantallasView.vue"),
    meta: { rutaName: "roles-permisos" },
  },
  {
    path: "/administracion/roles-permisos/usuarios/:userId",
    name: "UsuarioOverrides",
    component: () => import("../views/permisos/UsuarioOverridesView.vue"),
    meta: { rutaName: "roles-permisos" },
  },
  // ─── Perfil ───────────────────────────────────────────
  {
    path: "/perfil",
    name: "Perfil",
    component: () => import("../views/perfil/PerfilView.vue"),
  },
]
  


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(async (to, from, next) => {
  let user = JSON.parse(localStorage.getItem("token"));

  // Rutas públicas que no requieren autenticación
  const publicRoutes = ["Login", "ForgotPassword", "ResetPassword"];

  if (!user && !publicRoutes.includes(to.name)) {
    next({ name: "Login" });
    return;
  }

  // ─── Token expirado durante navegación ────────────────────────────────
  // Si el usuario existe pero el JWT expiró, limpiamos y redirigimos al login
  // sin pasar por el store (evita dependencia circular: user.js importa router).
  if (user && !publicRoutes.includes(to.name) && tokenExpirado()) {
    localStorage.removeItem("token");
    localStorage.removeItem("id_caja");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("recordar_sesion");
    sessionStorage.removeItem("sesion_activa");
    redirectLoginExpirado();
    next({ name: "Login" });
    return;
  }

  if (!to.matched.some((record) => record.meta.rutaName)) {
    next();
    return;
  }

  const rutas = to.matched[0].meta.rutaName;

  if (!user || typeof user.id_rol === "undefined") {
    next({ name: "Login" });
  } else if (typeof user.rutas[rutas] === "undefined") {
    next({ name: "Denegado" });
  } else if (user.rutas[rutas] === 1) {
    next();
  } else {
    next({ name: "Denegado" });
  }
});

export default router;
